export const MACRO_LAYOUT_2 = {
  version: '7.1.0',
  objects: [
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'background',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 271,
      top: 480,
      width: 2189,
      height: 3890,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.2467,
      scaleY: 0.2467,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: 'demo/macro/02/background.png',
      crossOrigin: null,
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'asset-00',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270,
      top: 448.2978,
      width: 1069,
      height: 1308,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.2215,
      scaleY: 0.2215,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: 'demo/macro/02/asset-00.png',
      crossOrigin: null,
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'logo',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270,
      top: 741.0688,
      width: 1348,
      height: 276,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.1547,
      scaleY: 0.1547,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: 'demo/macro/02/logo.png',
      crossOrigin: null,
      filters: []
    },
    {
      fontSize: 32,
      fontWeight: 'bold',
      fontFamily: "'DM Sans', sans-serif",
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: 'y poné tu plata en',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      type: 'IText',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270,
      top: 194.9524,
      width: 273.4833,
      height: 36.16,
      fill: '#0036E7',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.5716,
      scaleY: 1.5716,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    {
      fontSize: 32,
      fontWeight: 'bold',
      fontFamily: "'DM Sans', sans-serif",
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: 'movimiento',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      type: 'IText',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270,
      top: 248.1247,
      width: 187.7854,
      height: 36.16,
      fill: '#0036E7',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.5055,
      scaleY: 1.5055,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    {
      fontSize: 32,
      fontWeight: 'bold',
      fontFamily: "'DM Sans', sans-serif",
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: 'Hacelo en',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      type: 'IText',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 197.4325,
      top: 660.9716,
      width: 156.9055,
      height: 36.16,
      fill: '#0036E7',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.1455,
      scaleY: 1.1455,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    {
      fontSize: 32,
      fontWeight: 'bold',
      fontFamily: "'DM Sans', sans-serif",
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: 'un click',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      type: 'IText',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 362.081,
      top: 661.2737,
      width: 121.4835,
      height: 36.16,
      fill: '#ff85d8',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.1581,
      scaleY: 1.1581,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    {
      fontSize: 32,
      fontWeight: 'bold',
      fontFamily: "'DM Sans', sans-serif",
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: 'Abrí tu cuenta',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      type: 'IText',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270,
      top: 142.2195,
      width: 214.0668,
      height: 36.16,
      fill: '#ff85d8',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.4261,
      scaleY: 1.4261,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    }
  ],
  background: '#f0f0f0'
};
